import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { CustodianEntityStore } from '../../../../shared/state/credits/custodianEntities.store';
import { CreditCustodianEntity } from '../../../../shared/state/credits/credits.model';
import { AppConfigQuery } from '../../../../core/state/app-config/app-config.query';
import { SbHost } from '@models';

@Injectable({ providedIn: 'root' })
export class CustodianEntityService {
    baseApiUrl = `${this.config.get().consumerBaseUrl}/v1/consume_credit_data/custodian`;

    constructor(
        private custodianStore: CustodianEntityStore,
        private http: HttpClient,
        private config: AppConfigQuery
    ) {}

    getCustodianEntities(): Observable<CreditCustodianEntity[]> {
        return this.http.get<any>(this.baseApiUrl).pipe(
            map(
                (response) =>
                    response.results.client1.credit_custodian.map((custodianEntity) => ({
                        source: custodianEntity.source,
                        custodian: custodianEntity.custodian,
                        entity: custodianEntity.entity
                    })),

                tap((custodianEntities: CreditCustodianEntity[]) =>
                    this.custodianStore.set(custodianEntities)
                )
            )
        );
    }
}
